// traceability: requirements: [FR-002]
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import type { User, AuthTokens } from '@/types/models';

export function useAuth() {
  const navigate = useNavigate();
  const {
    user,
    tokens,
    isAuthenticated,
    isLoading,
    mfaRequired,
    login: storeLogin,
    logout: storeLogout,
    updateUser: storeUpdateUser,
    setMfaRequired,
  } = useAuthStore();

  const login = useCallback(
    (user: User, tokens: AuthTokens) => {
      storeLogin(user, tokens);
      navigate('/');
    },
    [storeLogin, navigate],
  );

  const logout = useCallback(() => {
    storeLogout();
    navigate('/login');
  }, [storeLogout, navigate]);

  const isAdmin = user?.role === 'admin';
  const isOperator = user?.role === 'operator' || isAdmin;

  return {
    user,
    tokens,
    isAuthenticated,
    isLoading,
    mfaRequired,
    isAdmin,
    isOperator,
    login,
    logout,
    updateUser: storeUpdateUser,
    setMfaRequired,
  };
}
